import { render } from "./BoardStat.vue?vue&type=template&id=62b3d3bc&scoped=true"
import script from "./BoardStat.vue?vue&type=script&lang=js"
export * from "./BoardStat.vue?vue&type=script&lang=js"

import "./BoardStat.vue?vue&type=style&index=0&id=62b3d3bc&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b3d3bc"]])

export default __exports__